import {
    FETCH_MESSAGES_BEGIN,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILURE,
    ADD_MESSAGE,
    SEND_MESSAGE_BEGIN,
    SEND_MESSAGE_SUCCESS,
    SHOW_WHATSAPP_CALLING_MODAL,
    HIDE_WHATSAPP_CALLING_MODAL,
    SEND_MESSAGE_FAILURE
} from '../constants'

// TODO Refactorizar para respetar el patron de una accion por archivo (One action one file)

const initialState = {
    whatsapp: {
        id: null,
        lead_id: null,
        lead: null,
        show_calling_modal: false,
        client_id: null,
        user_id: null,
        chat: [],
        profile_data: null,
        createdAt: null,
        createdBy: null,
        updatedAt: null,
        updatedBy: null,
        deletedAt: null,
        deletedBy: null
    },
    loading: false,
    error: null,
}

export function whatsappReducer(state = initialState, action) {
    const newWhatsapp = action.payload
    switch (action.type) {
        case SHOW_WHATSAPP_CALLING_MODAL:
            return {
                ...state,
                whatsapp: {
                    ...state.whatsapp,
                    lead: action.data.lead,
                    show_calling_modal: true,
                }
            }
        case HIDE_WHATSAPP_CALLING_MODAL:
            return {
                ...state,
                whatsapp: {
                    ...state.whatsapp,
                    lead: null,
                    show_calling_modal: false,
                }
            }
        case FETCH_MESSAGES_BEGIN:
        case SEND_MESSAGE_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            }
        case FETCH_MESSAGES_SUCCESS:
            newWhatsapp.chat = newWhatsapp?.chat?.reverse()
            return {
                ...state,
                loading: false,
                whatsapp: {
                    ...newWhatsapp,
                    show_calling_modal: state.whatsapp.show_calling_modal,
                    ...(state.whatsapp.show_calling_modal
                        ? { lead: state.whatsapp.lead }
                        : {}),
                }
            }
        case FETCH_MESSAGES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                whatsapp: state.whatsapp.show_calling_modal
                    ? state.whatsapp
                    : initialState.whatsapp
            }
        case ADD_MESSAGE:
            return {
                ...state,
                whatsapp: {
                    ...state.whatsapp,
                    chat: [...state.whatsapp.chat, action.payload]
                }
            }
        case SEND_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case SEND_MESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        default:
            return state
    }
}
